module.exports = __webpack_public_path__ + "img/how-to-flow-l-01.4207f6d7.svg";